'use client';

import React, { ReactNode } from 'react';
import { Select as CSelect } from 'antd';
import { mapModifiers } from '@/utils/funtion';
import Typography from '../typography';
import { Status } from '../rangepicker';
import Icon, { IconName } from '../icon';
import { chartIcon } from '@/statics/data';
const { Option } = CSelect;

export type ISelectType = {
  id: number | string;
  label: string;
  name: string;
  value: string;
  icon?: IconName;
  [x: string]: any;
};

interface ISelectProps {
  options: ISelectType[];
  placeholder?: string;
  label?: string;
  value?: ISelectType;
  isFlex?: boolean;
  defaultValue?: ISelectType;
  isRequired?: boolean;
  isState?: boolean;
  error?: string;
  id?: string;
  className?: string;
  isClear?: boolean;
  disabled?: boolean;
  isColor?: boolean;
  isMobile?: boolean;
  allowClear?: boolean;
  errorMessage?: string;
  withIcon?: boolean;
  showSearch?: boolean;
  status?: Status;
  listHeight?: number;
  popupMatchSelectWidth?: boolean | number;
  onChange?: (item: ISelectType) => void;
  suffixIcon?: ReactNode;
}

const Select: React.FC<ISelectProps | any> = ({
  options,
  onChange,
  className,
  value,
  placeholder,
  defaultValue,
  disabled,
  allowClear,
  isMobile = false,
  showSearch = true,
  isRequired,
  error,
  label,
  errorMessage,
  status,
  withIcon = false,
  popupMatchSelectWidth,
  listHeight,
  suffixIcon,
  ...props
}) => (
  <div className={mapModifiers('a-select', status)}>
    {label && (
      <div className={'a-select_label'}>
        <Typography content={label} />
        {isRequired && <span style={{ color: 'red', marginLeft: 4 }}>*</span>}
      </div>
    )}
    <CSelect
      aria-labelledby={label ? `-label` : undefined}
      aria-label={label ? undefined : placeholder}
      onSelect={(_, option: any) => {
        const newOption = options?.find(
          (i: ISelectType) => i?.value === option?.value,
        );
        if (onChange) onChange(newOption as any);
      }}
      {...(suffixIcon && { suffixIcon })}
      showSearch={showSearch}
      className={className}
      value={value}
      status={status}
      placeholder={placeholder}
      defaultValue={defaultValue}
      disabled={disabled}
      listHeight={listHeight}
      popupMatchSelectWidth={popupMatchSelectWidth}
      optionFilterProp="children"
      filterOption={(input, option) => {
        return (option?.children ?? '')
          ?.toLowerCase()
          .includes(input.toLowerCase());
      }}
      allowClear={allowClear}
      labelRender={(props: {
        title: undefined | string;
        value: number | string | undefined;
        label: undefined | string;
        key: string | undefined;
        disabled: boolean | undefined;
      }) => {
        if (typeof props?.value !== 'number') {
          const newValue = props?.value?.replace('-', '_');
          if (isMobile && newValue)
            return (
              <Icon iconName={chartIcon[newValue] as IconName} size="28x28" />
            );
        }
        return <p>{props.label}</p>;
      }}
      {...props}
    >
      {!!options?.length &&
        options?.map((item: ISelectType) => (
          <Option key={item?.id} value={item?.value}>
            {withIcon ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  gap: 8,
                }}
              >
                <Icon
                  iconName={item.icon}
                  style={{
                    minWidth: 25,
                  }}
                />
                {item?.label}
              </div>
            ) : (
              item?.label
            )}
          </Option>
        ))}
    </CSelect>
    {errorMessage && (
      <div className="a-select-error_message">{errorMessage}</div>
    )}
  </div>
);

export default Select;
